module.exports = __webpack_public_path__ + "static/media/_northen-cyprus.4b859f93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_northen-cyprus.svg
// module id = 2341
// module chunks = 7